import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import DriverTrackPage, { resumeDriverPath, DriverHome } from './pages/DriverTrackPage';
import BrokerTrackPage from './pages/BrokerTrackPage';

// /t and /t/<token> are the OC driver tracking link — public, no sign-in, so
// they render on their own instead of inside the app shell.
const isDriverPath = (p) => /^\/t(\/|$)/.test(p);
// /driver is the company driver's own profile: sign in with the cell, their loads, paperwork, messages
const isDriverHome = (p) => /^\/driver\/?$/.test(p);
// /s/<token> is the broker's live tracking link for one load — public, no sign-in.
const isBrokerTrackPath = (p) => /^\/s\/[\w-]+/.test(p);
const native = !!(window.Capacitor && window.Capacitor.isNativePlatform && window.Capacitor.isNativePlatform());
let redirecting = false;

if (native) {
  // A tracking link tapped in a text opens the app (universal link); send the
  // web view to it. The launch URL is handled once so "Exit driver mode" sticks.
  import('@capacitor/app').then(({ App: CapApp }) => {
    const go = (url) => {
      try {
        const u = new URL(url);
        if (isDriverPath(u.pathname) && u.pathname !== window.location.pathname) window.location.assign(u.pathname);
      } catch { /* not a URL we handle */ }
    };
    CapApp.addListener('appUrlOpen', (e) => go(e && e.url));
    CapApp.getLaunchUrl().then((r) => {
      if (!r || !r.url) return;
      let seen = null;
      try { seen = sessionStorage.getItem('ta-launch-url'); sessionStorage.setItem('ta-launch-url', r.url); } catch { /* storage blocked */ }
      if (seen !== r.url) go(r.url);
    }).catch(() => {});
  }).catch(() => { /* @capacitor/app missing */ });
  // Relaunched while sharing a load → back to the driver page so tracking resumes.
  const resume = resumeDriverPath();
  if (resume && window.location.pathname === '/') { redirecting = true; window.location.replace(resume); }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
if (!redirecting) {
  root.render(
    <React.StrictMode>
      {isBrokerTrackPath(window.location.pathname) ? <BrokerTrackPage /> : isDriverPath(window.location.pathname) ? <DriverTrackPage /> : isDriverHome(window.location.pathname) ? <DriverHome /> : <App />}
    </React.StrictMode>
  );
}
